import React from 'react';
import dayjs from 'dayjs';
import { useGetProviderDashboardCcmDetails } from 'infrastructure/hooks/provider-dashboard/use-get-ccm-details';
import { useGetProviderDashboardRpmDetails } from 'infrastructure/hooks/provider-dashboard/use-get-rpm-details';
import { useGetProviderDashboardPatientReports } from 'infrastructure/hooks/provider-dashboard/use-get-patient-reports';
import { useProviderDashboardTab } from 'infrastructure/hooks/provider-dashboard';

import { PatientsReportCard } from './patients-report-card';
import { RpmDetailsCard } from './rpm-details-card';
import { CcmDetailsCard } from './ccm-details-card';

interface IProviderDashboardSummaryTabProps {
  dateRange: [Date, Date];
  clinicGuid: string[];
  parentClinicGuid: string[];
  providerGuid?: string;
}

export const ProviderDashboardSummaryTab: React.FC<
  IProviderDashboardSummaryTabProps
> = ({ dateRange, clinicGuid, parentClinicGuid, providerGuid }) => {
  const { module, setModule } = useProviderDashboardTab();

  const startDate = dayjs(dateRange[0]).format('YYYY-MM-DD');
  const endDate = dayjs(dateRange[1]).format('YYYY-MM-DD');

  const filtersEnabled = Boolean(startDate && endDate);

  const {
    patientReports,
    isLoading: patientsLoading,
    isFetching: patientsFetching,
  } = useGetProviderDashboardPatientReports(
    {
      startDate,
      endDate,
      clinicGuid,
      parentClinicGuid,
      providerGuid,
      module,
    },
    filtersEnabled,
  );

  const {
    rpmDetails,
    isLoading: rpmLoading,
    isFetching: rpmFetching,
  } = useGetProviderDashboardRpmDetails(
    {
      startDate,
      endDate,
      clinicGuid,
      parentClinicGuid,
      providerGuid,
    },
    filtersEnabled,
  );

  const {
    ccmDetails,
    isLoading: ccmLoading,
    isFetching: ccmFetching,
  } = useGetProviderDashboardCcmDetails(
    {
      startDate,
      endDate,
      clinicGuid,
      parentClinicGuid,
      providerGuid,
    },
    filtersEnabled,
  );

  return (
    <>
      <PatientsReportCard
        data={patientReports}
        isLoading={patientsLoading || patientsFetching}
        module={module}
        setModule={setModule}
        exportFilters={{
          startDate,
          endDate,
          clinicGuid,
          parentClinicGuid,
          providerGuid,
        }}
      />
      <RpmDetailsCard data={rpmDetails} isLoading={rpmLoading || rpmFetching} />
      <CcmDetailsCard data={ccmDetails} isLoading={ccmLoading || ccmFetching} />
    </>
  );
};
